__turbopack_context__.v({
  "emailInput": "InputEmail-module-scss-module__Mfi5-W__emailInput",
  "helperText": "InputEmail-module-scss-module__Mfi5-W__helperText",
  "hiddenInput": "InputEmail-module-scss-module__Mfi5-W__hiddenInput",
  "inputIndicator": "InputEmail-module-scss-module__Mfi5-W__inputIndicator",
  "root": "InputEmail-module-scss-module__Mfi5-W__root",
  "suggestedEmail": "InputEmail-module-scss-module__Mfi5-W__suggestedEmail",
});
